<div class="flex flex-row">
    <ul class="breadcrumbs flex flex-row items-center gap-x-2">
        <li>
            <a
                routerLink="/"
                [matTooltip]="appService.language_dictionary.main_home_page"
                class="breadcrumbs-link-home"
            >
                <mat-icon class="breadcrumbs-icon-home" fontSet="mdi" fontIcon="mdi-home"></mat-icon>
            </a>
        </li>
        <ng-container *ngIf="(service.breadcrumbsList$ | async)?.length">
            <li *ngFor="let breadcrumb of service.breadcrumbsList$ | async; let last = last; trackBy: trackByLink">
                <ng-container *ngIf="!last && breadcrumb.link; else emptyLink">
                    <a [routerLink]="breadcrumb.link">{{ breadcrumb.name }}</a>
                </ng-container>
                <ng-template #emptyLink>
                    <span class="cursor-default">{{ breadcrumb.name }}</span>
                </ng-template>
            </li>
        </ng-container>
    </ul>
</div>
